<template>
  <ConfirmDlg ref="dlgClientRemove" title="Želite odstraniti naročnika?" @confirm="removeClient" />
  <Modal ref="dlgClient" :unmountOnClose="true">
    <template #title> Dodaj novega naročnika</template>
    <template #body>
      <ClientAdd @added="clientAdded()" @close="dlgClient.close()" :sifData="sifData" ref="clientAdd" />
    </template>
  </Modal>
  <div class="inner">
    <Nav />
    <div class="box">
      <div class="columns">
        <div class="column col-6">
          <template v-if="!$user.sipass">
            <h2>Digitalno potrdilo - uporabnik</h2>
            <table class="">
              <tr>
                <td>Lastnik:</td>
                <td>{{ certData.owner }}</td>
              </tr>
              <tr>
                <td>Izdajatelj:</td>
                <td>{{ certData.issuer }}</td>
              </tr>
              <tr>
                <td>Veljavnost:</td>
                <td>{{ certData.validFromTo }}</td>
              </tr>
            </table>
            <div class="padding-top20">
              <div class="text-bold">Menjava digitalnega potrdila</div>
              <div class="padding-top5 padding-bottom10">Na vaš e-naslov vam bo poslana povezava prek katere izvedete spremembo digitalnega potrdila. Pred klikom na povezavo je potrebno zapreti vse brskalnike, po kliku na povezavo pa izberete novo digitalno potrdilo. Povezava bo aktivna 10 minut.</div>
              <a href @click.prevent="changeCert" class="text-bold">Zamenjaj digitalno potrdilo</a>
            </div>
            <div class="padding-top30" v-if="!$user.isB2b">
              <h2>Centralna prijava SI-PASS</h2>
              <a class="button sipass" href="/sipass"> &nbsp; &nbsp; VSTOP</a>
            </div>
          </template>
          <template v-else>
            <h2>SI-PASS identiteta</h2>
            <table class="">
              <tr>
                <td>Lastnik:</td>
                <td>{{ sipassData.subject }}</td>
              </tr>
              <tr>
                <td>Oznaka prijave:</td>
                <td>{{ sipassData.ident }}</td>
              </tr>
            </table>
          </template>
        </div>
        <div class="column col-6">
          <template v-if="!$user.sipass">
            <form>
              <h2>Sprememba gesla</h2>
              <div class="toast toast-error" v-if="$user.changePassword">Potrebna je sprememba gesla.</div>
              <InputWrapper :errors="errorMap($appErrors, 'passwordCurrent')">
                <label class="form-label" for="passwordCurrent">Obstoječe geslo</label>
                <InputPassword id="passwordCurrent" v-model="data.passwordCurrent" />
              </InputWrapper>
              <InputWrapper :errors="errorMap($appErrors, 'password')">
                <label class="form-label" for="password"> Novo geslo</label>
                <InputPassword id="password" v-model="data.password" />
              </InputWrapper>
              <InputWrapper :errors="errorMap($appErrors, 'passwordConfirm')">
                <label class="form-label" for="passwordConfirm"> Ponovi novo geslo</label>
                <InputPassword id="passwordConfirm" v-model="data.passwordConfirm" />
              </InputWrapper>
              <br />
              <button class="button" @click.prevent="updatePassword">Spremeni</button>
            </form>
            <br /><br />
          </template>
          <form>
            <h2>Obveščanja</h2>
            <InputCheck v-model="chk" :disabled="true">Obvesti me o novem uporabniku na mojem naročniku </InputCheck>
            <InputCheck v-model="userData.notifications">Obvesti me o novem mesečnem poročanju (1. v mesecu)</InputCheck>
            <div class="columns">
              <div class="column col-2">
                <label class="form-label" for="email">na E-naslov</label>
              </div>
              <div class="column col">
                <InputWrapper :errors="errorMap($appErrors, 'email')">
                  <InputText id="email" v-model="userData.email" />
                </InputWrapper>
              </div>
            </div>
            <br />
            <button class="button" @click.prevent="submitNotifications">Shrani</button>
          </form>
        </div>
      </div>
    </div>
    <div class="box margin-top30">
      <h2>Pravica poročanja</h2>
      <a class="text-bold" href @click.prevent="dlgClient.open()">Dodaj naročnika</a>
      <br />
      <br />
      <table class="table compact table-hover">
        <thead>
          <th>Uporabnik</th>
          <th>Davčna številka</th>
          <th>Matična številka</th>
          <th>Naziv naročnika</th>
          <th>Tip uporabnika</th>
          <th>Akcija</th>
        </thead>
        <tbody>
          <tr v-for="d in sifData.clientListAll" :key="d.id">
            <td>{{ d.user }}</td>
            <td>{{ d.taxNumber }}</td>
            <td>{{ d.idNumber }}</td>
            <td>{{ d.title }}</td>
            <td>{{ d.userType }}</td>
            <td>
              <div v-if="d.idUser === $user.id"><a href @click.prevent="dlgClientRemove.open(d.id)">odstrani</a></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script lang="ts">
import Modal from '@/components/common/Modal.vue'
import ConfirmDlg from '@/components/common/ConfirmDlg.vue'
import ClientAdd from '@/components/ClientAdd.vue'
import InputWrapper from '@/components/common/InputWrapper.vue'
import InputText from '@/components/common/InputText.vue'
import InputPassword from '@/components/common/InputPassword.vue'
import InputCheck from '@/components/common/InputCheck.vue'

import { useApi } from '@/lib/api'
import { errorMap } from '@/lib/filters'
import { defineComponent, ref, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import { GlobalState } from '@/lib/types'
import Nav from '@/components/Nav.vue'

export default defineComponent({
  components: { InputWrapper, InputText, InputCheck, Nav, Modal, ClientAdd, ConfirmDlg, InputPassword },
  setup() {
    const _api = useApi()
    const _store = useStore<GlobalState>()
    const _inst = getCurrentInstance()
    const data = ref({})
    const certData = ref({})
    const sipassData = ref({})
    const dlgClient = ref()
    const dlgClientRemove = ref()
    const chk = ref(true)
    const sifData = ref({ clientList: [], clientListAll: [] })
    const userData = ref({ email: _store.state.user.email, notifications: _store.state.user.notifications })

    const updatePassword = async () => {
      const res = await _api.post<any>('passwordWrite', data.value)
      if (res.status === 200) {
        data.value = {}
        _store.commit('userChangePassword')
        _inst?.appContext.config.globalProperties.emitter.emit('showToaster', { theme: 'green', text: 'Geslo spremenjeno.' })
      }
    }

    const changeCert = async () => {
      await _api.get('changeCert')
      _inst?.appContext.config.globalProperties.emitter.emit('showToaster', { theme: 'green', text: 'E-sporočilo poslano.' })
    }

    const getSifData = async () => {
      // let res = await _api.cache.get<any>('sifList?type=client')
      // sifData.value.clientList = res.data

      const res = await _api.get<any>('clientList?all=1')
      sifData.value.clientListAll = res.data
    }

    const getLoginData = async () => {
      if (!_store.state.user.sipass) {
        const res = await _api.axios.get<any>('cert')
        if (res.status === 200) {
          certData.value = res.data.cert
        }
      } else {
        const res = await _api.axios.get<any>('sipassInfo')
        if (res.status === 200) {
          sipassData.value = res.data
        }
      }
    }

    const clientAdded = async () => {
      dlgClient.value.close()
      _inst?.appContext.config.globalProperties.emitter.emit('showToaster', { theme: 'green', text: 'Naročnik dodan.' })

      const res = await _api.get<any>('clientList?all=1')
      sifData.value.clientListAll = res.data
    }

    const submitNotifications = async () => {
      const res = await _api.post<any>('userNotificationsWrite', userData.value)
      if (res.status === 200) {
        _inst?.appContext.config.globalProperties.emitter.emit('showToaster', { theme: 'green', text: 'Podatki shranjeni.' })
        _store.state.user.notifications = userData.value.notifications
        _store.state.user.email = userData.value.email
      }
    }

    const removeClient = async (e: any) => {
      if (e) {
        await _api.get('clientDelete?id=' + dlgClientRemove.value.tag, _store.state.user)
        _inst?.appContext.config.globalProperties.emitter.emit('showToaster', { theme: 'green', text: 'Naročnik odstranjen.' })

        const res = await _api.get<any>('clientList?all=1')
        sifData.value.clientListAll = res.data
      }
    }

    getLoginData()
    getSifData()

    return { sifData, dlgClient, dlgClientRemove, errorMap, data, updatePassword, changeCert, certData, sipassData, clientAdded, submitNotifications, removeClient, chk, userData }
  }
})
</script>
